import { initializeAnalytics as baseInitializeAnalytics } from '@chilecompra/react-kit'
import GoogleAnalytics from 'react-ga'
import {
  REACT_APP_GOOGLE_ANALYTICS_KEY,
  REACT_APP_GOOGLE_TASK_MANAGER_ID,
  REACT_APP_HOTJAR_ID,
  REACT_APP_HOTJAR_SNIPPET_VERSION
} from './environment'

/**
 * To initialize the analytics tools.
 */
const initializeAnalytics = () => {
  baseInitializeAnalytics({
    gaKey: REACT_APP_GOOGLE_ANALYTICS_KEY,
    gtmId: REACT_APP_GOOGLE_TASK_MANAGER_ID,
    hotjarId: REACT_APP_HOTJAR_ID,
    hotjarSV: REACT_APP_HOTJAR_SNIPPET_VERSION
  })
}

export const sendAnalyticsEvent = event => {
  GoogleAnalytics.event(event)
}

export default initializeAnalytics
